/**
 * @fileoverview 著作権表示コンポーネント
 *
 * このファイルでは、フッターに表示される著作権表示（コピーライト）を
 * 定義しています。企業名と年号を含む標準的な著作権表記を提供します。
 */

/**
 * 著作権表示コンポーネント
 *
 * アプリケーションのフッターで使用される著作権表示を提供します。
 * 「© [年] Jij inc. All rights reserved.」という形式で著作権情報を
 * 表示します。テキストのスタイリングも含まれています。
 *
 * @returns {JSX.Element} 著作権表示要素
 */
export default function CopyRights() {
  return (
    <div className="w-fit text-center text-sm text-gray-500 dark:text-gray-400">
      <p>© 2025 Jij inc. All rights reserved.</p>
    </div>
  );
}
